import React, { useEffect, useState } from 'react';

import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';

import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';
import { useScrollToHash } from '@nhl/react-hooks/lib/useScrollToHash';

import { glossaryActions } from '../../../redux/ducks/glossary';

import './styles';

const GLOSSARY_TITLE = 'glossary';

const Glossary = () => {
    const dispatch = useDispatch();
    const glossary = useSelector(({ glossary }) => glossary);
    const [scrollTarget, setScrollTarget] = useState(null);

    useEffect(() => {
        dispatch(glossaryActions.requestGlossary());
    }, []);

    useEffect(() => {
        const { abbreviation, name } = queryString.parse(window.location.search);
        if (abbreviation || name) {
            const equalsIgnoreCase = (a, b) => a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0;
            const matches = glossary.filter(
                (item) => equalsIgnoreCase(item.abbreviation, abbreviation) || equalsIgnoreCase(item.fullName, name),
            );
            if (matches.length > 0) {
                setScrollTarget(matches[0].fullName);
            }
        } else {
            const hashString = decodeURI(window.location.hash.slice(1));
            if (hashString) {
                setScrollTarget(hashString);
            }
        }
    }, [glossary, window.location.search]);

    useScrollToHash(scrollTarget ? `#${scrollTarget}` : null, scrollTarget);

    // Get letters to be displayed for index
    const glossaryLetters = {};
    glossary.forEach((item) => {
        const { fullName } = item;
        const letter = isNaN(fullName.charAt(0)) ? fullName.charAt(0) : '#';
        if (!glossaryLetters[letter]) {
            glossaryLetters[letter] = fullName;
        }
    });

    // Assign a hash for each glossary term and render index letters
    const glossaryIndex = Object.keys(glossaryLetters).map((glossaryLetter, i) => {
        const glossaryName = glossaryLetters[glossaryLetter];
        return (
            <a href={`./glossary#${glossaryName}`} key={glossaryLetter}>
                {i ? '|' : ''}
                <span>{glossaryLetter}</span>
            </a>
        );
    });

    const isMobileApp = !document.getElementsByClassName('nhl-c-header')[0];
    const glossaryContent = glossary.map((g) => (
        <figure key={g.id} id={g.fullName} className={isMobileApp ? 'mobileAppFigure' : undefined}>
            <figcaption>
                {g.fullName}, {g.abbreviation}
            </figcaption>
            {g.definition}
        </figure>
    ));

    return (
        <LoadingDisplay isLoading={glossary.length === 0}>
            <div role="tabpanel" id={`${GLOSSARY_TITLE}-tabpanel`} aria-labelledby={GLOSSARY_TITLE}>
                <section className={GLOSSARY_TITLE}>
                    <div className={isMobileApp ? 'indexDiv mobileAppIndexDiv' : 'indexDiv'}>{glossaryIndex}</div>
                    {glossaryContent}
                </section>
            </div>
        </LoadingDisplay>
    );
};

export { Glossary as Component };
